import { render, staticRenderFns } from "./CustomBlockAttributePicker.vue?vue&type=template&id=00472f8e&scoped=true"
import script from "./CustomBlockAttributePicker.vue?vue&type=script&lang=js"
export * from "./CustomBlockAttributePicker.vue?vue&type=script&lang=js"
import style0 from "./CustomBlockAttributePicker.vue?vue&type=style&index=0&id=00472f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00472f8e",
  null
  
)

export default component.exports